/// <amd-module name="Likes/LikeSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";

import { LikesConstants } from "Likes/LikesConstants";
import { LikeArtifactInfo } from "Likes/LikeModels";
import {
    SocialEngagementRecord,
    SocialEngagementCreateParameter,
    SocialEngagementType
} from "Likes/Contracts/Social";
import { ISocialRestClient } from "Likes/RestClient/Social";

export class LikeSource {
    private _socialClient: ISocialRestClient;
    constructor(
        private _pageContext: IVssPageContext
    ) {
        this._socialClient = this._pageContext.getRestClient<ISocialRestClient>("ISocialRestClient");
    }

    public async getLikes(likeArtifactInfo: LikeArtifactInfo): Promise<SocialEngagementRecord> {
        return this._socialClient.getSocialEngagement(
            likeArtifactInfo.artifactType,
            likeArtifactInfo.artifactId,
            SocialEngagementType.Likes,
            likeArtifactInfo.artifactScopeType,
            likeArtifactInfo.artifactScopeId);
    }

    public async deleteLike(likeArtifactInfo: LikeArtifactInfo): Promise<SocialEngagementRecord> {
        return this._socialClient.deleteSocialEngagement(
            likeArtifactInfo.artifactType,
            likeArtifactInfo.artifactId,
            SocialEngagementType.Likes,
            likeArtifactInfo.artifactScopeType,
            likeArtifactInfo.artifactScopeId);
    }

    public async createLike(likeArtifactInfo: LikeArtifactInfo): Promise<SocialEngagementRecord> {
        let likeCreateParameter: SocialEngagementCreateParameter = {
            artifactId: likeArtifactInfo.artifactId,
            artifactType: likeArtifactInfo.artifactType,
            engagementType: SocialEngagementType.Likes,
            artifactScope: {
                id: likeArtifactInfo.artifactScopeId,
                name: "",
                type: likeArtifactInfo.artifactScopeType
            }
        };
        return this._socialClient.createSocialEngagement(likeCreateParameter);
    }

    public async getLikedUsers(likeArtifactInfo: LikeArtifactInfo): Promise<IdentityRef[]> {
        return this._socialClient.getEngagedUsers(
            likeArtifactInfo.artifactType,
            likeArtifactInfo.artifactId,
            SocialEngagementType.Likes,
            likeArtifactInfo.artifactScopeType,
            likeArtifactInfo.artifactScopeId,
            LikesConstants.TopLikedUsersFetchCount);
    }
}
